import { render, staticRenderFns } from "./pintuanOrder.vue?vue&type=template&id=b5ebe2e0&scoped=true"
import script from "./pintuanOrder.vue?vue&type=script&lang=js"
export * from "./pintuanOrder.vue?vue&type=script&lang=js"
import style0 from "./pintuanOrder.vue?vue&type=style&index=0&id=b5ebe2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ebe2e0",
  null
  
)

export default component.exports